import { Direction } from "../direction";
import { XY } from "../xy";

export class Room {
	minXY: XY;
	maxXY: XY;

	constructor(minXY: XY, maxXY: XY) {
		this.minXY = minXY;
		this.maxXY = maxXY;
	}

	getWidth(): number {
		return this.maxXY.x - this.minXY.x + 1;
	}

	getHeight(): number {
		return this.maxXY.y - this.minXY.y + 1;
	}

	contains(xy: XY): boolean {
		return xy.x >= this.minXY.x && xy.x <= this.maxXY.x && xy.y >= this.minXY.y && xy.y <= this.maxXY.y;
	}

	containsInside(xy: XY): boolean {
		return xy.x > this.minXY.x && xy.x < this.maxXY.x && xy.y > this.minXY.y && xy.y < this.maxXY.y;
	}

	getCenterXY(): XY {
		return new XY(Math.floor((this.minXY.x + this.maxXY.x) / 2), Math.floor((this.minXY.y + this.maxXY.y) / 2));
	}

	getInnerArea(): XY[] {
		const result: XY[] = [];
		for (let x = this.minXY.x + 1; x <= this.maxXY.x - 1; x++) {
			for (let y = this.minXY.y + 1; y <= this.maxXY.y - 1; y++) {
				result.push(new XY(x, y));
			}
		}
		return result;
	}

	getAllTiles(): XY[] {
		const result: XY[] = [];
		for (let x = this.minXY.x; x <= this.maxXY.x; x++) {
			for (let y = this.minXY.y; y <= this.maxXY.y; y++) {
				result.push(new XY(x, y));
			}
		}
		return result;
	}

	getWallTiles(): XY[] {
		return this.getAllTiles().filter(
			(xy) => xy.x === this.minXY.x || xy.x === this.maxXY.x || xy.y === this.minXY.y || xy.y === this.maxXY.y,
		);
	}

	isAtBorder(xy: XY): boolean {
		return (
			xy.x === this.minXY.x + 1 || xy.x === this.maxXY.x - 1 || xy.y === this.minXY.y + 1 || xy.y === this.maxXY.y - 1
		);
	}

	getBorderPositions(direction: Direction): XY[] {
		const inner = this.getInnerArea();
		switch (direction) {
			case Direction.N:
				return inner.filter((xy) => xy.y === this.maxXY.y - 1);
			case Direction.S:
				return inner.filter((xy) => xy.y === this.minXY.y + 1);
			case Direction.E:
				return inner.filter((xy) => xy.x === this.minXY.x + 1);
			case Direction.W:
				return inner.filter((xy) => xy.x === this.maxXY.x - 1);
			default:
				throw new Error("getBorderPositions requires a cardinal direction");
		}
	}

	getCornerPositions(direction: Direction): XY[] {
		switch (direction) {
			case Direction.NW:
				return [new XY(this.minXY.x + 1, this.maxXY.y - 1)];
			case Direction.NE:
				return [new XY(this.maxXY.x - 1, this.maxXY.y - 1)];
			case Direction.SE:
				return [new XY(this.maxXY.x - 1, this.minXY.y + 1)];
			case Direction.SW:
				return [new XY(this.minXY.x + 1, this.minXY.y + 1)];
			default:
				throw new Error("getCornerPositions requires a diagonal direction");
		}
	}
}
